import fetch from './fetch';
import { PaymentMethodApi } from './paymentMethod.types';
import { IS_WEBVIEW_IOS } from '../constants';

export const getPaymentProviderListByPlanId = (planId: string): PaymentMethodApi => {
  const path = `/offers/${planId}/payment-providers${IS_WEBVIEW_IOS ? '?webview=ios' : ''}`;
  return fetch('GET', path);
};
